export default {
  itemDescriptionDefaultColor: undefined,
  itemDescriptionFontSize: '0.8125rem',
  itemDescriptionFontWeight: undefined,
  itemDescriptionLineHeight: '1.125rem',
};
